<script>
import { getContext } from 'svelte';
import Line from 'svelte-chartjs/src/Line.svelte';
import FixedContent from '../FixedContent/FixedContent.svelte';
import ContentBox from '../ContentBox/ContentBox.svelte';

const state = getContext('state');

const getLabels = () => (
  $state.data.matchDisplay.map((match) => `${new Date(match.started_at * 1000).getDate()}/${new Date(match.started_at * 1000).getMonth() + 1}/${new Date(match.started_at * 1000).getFullYear()}`).reverse()
);

const getKDData = () => (
  $state.data.matchDisplay.map((match) => match.player.player_stats['K/D Ratio']).reverse()
);

let dataLine = {
    labels: getLabels(),
    datasets: [
      {
        label: "KD",
        lineTension: 0.3,
        fill: false,
        backgroundColor: "rgba(225, 204,230, .3)",
        borderColor: "rgb(55, 65, 81)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgb(55, 65, 81)",
        pointBackgroundColor: "rgb(55, 65, 81)",
        pointBorderWidth: 10,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgb(0, 0, 0)",
        pointHoverBorderColor: "rgba(220, 220, 220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: getKDData(),
      },
      {
        label: 'Neutral KD',
        lineTension: 0.3,
        fill: false,
        backgroundColor: "rgba(225, 204,230, .3)",
        borderColor: "rgb(156, 163, 175)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointRadius: 0,
        data: getKDData().map((kd) => 1),
      }
    ]
  };
</script>

<FixedContent>
  <ContentBox>
    <Line data={dataLine} options={{ responsive: true }}/>
  </ContentBox>
</FixedContent>
